import React, { useState, useContext, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { createMuiTheme, Container, Toolbar, Typography, IconButton, Grid, CssBaseline, Avatar, Backdrop, CircularProgress, AppBar } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from '@material-ui/styles';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import styles from "../../jss/material-dashboard-react/views/dashboardStyle.js";
import { HttpService } from "../../apiAuthorization/httpService";
import { GlobalTheme } from '../../layouts/theme';
import { Theme } from '../contexts/themeContext';
import { Modules } from '../contexts/modulesContext';
import GridContainer from "../grid/gridContainer.js";
import GridItem from "../grid/gridItem.js";
import Card from "../card/card.js";
import CardBody from "../card/cardBody.js";
import SmallMenu from '../header/smallMenu';
import StatusIcon from '../common/statusIcon';

const useStyles = makeStyles(styles);

export default function ModuleOrder(props) {
    const classes = useStyles();
    const { theme } = useContext(Theme);
    const { modules, setModules } = useContext(Modules);
    const [modulesList, setModulesList] = useState([]);
    const [modified, setModified] = useState(false);
    const [backDrop, setBackDrop] = useState(false);
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);

    const getItemStyle = (isDragging, draggableStyle) => ({
        padding: 8,
        margin: '0 0 8px 0',
        color: isDragging ? "#FFFFFF" : "#000000",
        background: isDragging ? "#004085" : "#9FCDFF",
        ...draggableStyle
    });

    const getListStyle = isDraggingOver => ({
        background: currentTheme.secondary,
        padding: 8,
        width: 350
    });

    const handleDragEnd = (results) => {
        if (results.destination !== null) {
            let data = [...modulesList];
            let [selectedRow] = data.splice(results.source.index, 1);
            data.splice(results.destination.index, 0, selectedRow);
            setModulesList(data);
            setModified(true);
        }
    };

    const ModuleItem = props => {
        let module = props.title;

        if (module === "Staffing") {
            return (
                <Grid container direction="row" alignItems="center">
                    <Avatar style={{ backgroundColor: currentTheme.secondary }}>S</Avatar>
                    <Typography className={classes.smallMenulink}>&nbsp;&nbsp;&nbsp;Staffing</Typography>
                </Grid>
            )
        }
        else if (module === "SafetyCoaching") {
            return (
                <Grid container direction="row" alignItems="center">
                    <Avatar style={{ backgroundColor: currentTheme.secondary }}>SC</Avatar>
                    <Typography className={classes.smallMenulink}>&nbsp;&nbsp;&nbsp;Safety Coaching</Typography>
                </Grid>
            )
        }
        else if (module === "Journal") {
            return (
                <Grid container direction="row" alignItems="center">
                    <Avatar style={{ backgroundColor: currentTheme.secondary }}>J</Avatar>
                    <Typography className={classes.smallMenulink}>&nbsp;&nbsp;&nbsp;Journal</Typography>
                </Grid>
            )
        }
        else if (module === "Huddle") {
            return (
                <Grid container direction="row" alignItems="center">
                    <Avatar style={{ backgroundColor: currentTheme.secondary }}>H</Avatar>
                    <Typography className={classes.smallMenulink}>&nbsp;&nbsp;&nbsp;Huddle</Typography>
                </Grid>
            )
        }
        else if (module === "Round") {
            return (
                <Grid container direction="row" alignItems="center">
                    <Avatar style={{ backgroundColor: currentTheme.secondary }}>R</Avatar>
                    <Typography className={classes.smallMenulink}>&nbsp;&nbsp;&nbsp;Round</Typography>
                </Grid>
            )
        }
        else if (module === "Coach") {
            return (
                <Grid container direction="row" alignItems="center">
                    <Avatar style={{ backgroundColor: currentTheme.secondary }}>TC</Avatar>
                    <Typography className={classes.smallMenulink}>&nbsp;&nbsp;&nbsp;Team Coach</Typography>
                </Grid>
            )
        }
        else if (module === "PatientSitting") {
            return (
                <Grid container direction="row" alignItems="center">
                    <Avatar style={{ backgroundColor: currentTheme.secondary }}>PO</Avatar>
                    <Typography className={classes.smallMenulink}>&nbsp;&nbsp;&nbsp;Patient Observation</Typography>
                </Grid>
            )
        }
        else if (module === "RDOAccountVisitation") {
            return (
                <Grid container direction="row" alignItems="center">
                    <Avatar style={{ backgroundColor: currentTheme.secondary }}>AV</Avatar>
                    <Typography className={classes.smallMenulink}>&nbsp;&nbsp;&nbsp;RDO Account Visitation</Typography>
                </Grid>
            )
        }
        else if (module === "VisitationEVS") {
            return (
                <Grid container direction="row" alignItems="center">
                    <Avatar style={{ backgroundColor: currentTheme.secondary }}>VE</Avatar>
                    <Typography className={classes.smallMenulink}>&nbsp;&nbsp;&nbsp;Visitation EVS</Typography>
                </Grid>
            )
        }
        else if (module === "Recovery") {
            return (
                <Grid container direction="row" alignItems="center">
                    <Avatar style={{ backgroundColor: currentTheme.secondary }}>RE</Avatar>
                    <Typography className={classes.smallMenulink}>&nbsp;&nbsp;&nbsp;Recovery EVS</Typography>
                </Grid>
            )
        }
        else if (module === "TeamPRO") {
            return (
                <Grid container direction="row" alignItems="center">
                    <Avatar style={{ backgroundColor: currentTheme.secondary }}>TP</Avatar>
                    <Typography className={classes.smallMenulink}>&nbsp;&nbsp;&nbsp;TeamPRO</Typography>
                </Grid>
            )
        }
        else {
            return <></>
        }
    };

    const saveModuleDisplayOrder = (goBack) => {
        if (backDrop) {
            return;
        }
        else if (modified) {
            let displayOrders = [];

            for (let index = 0; index < modulesList.length; index++) {
                displayOrders.push(modulesList[index].title);
            }
            setBackDrop(true);
            HttpService.post('/Home/SaveModuleDisplayOrder', { 'displayOrders': JSON.stringify(displayOrders) })
                .then(result => {
                    setModules(modulesList);
                    setModified(false);
                    setBackDrop(false);
                    if (goBack)
                        props.history.push('/');
                },
                    (error) => {
                        console.log(error);
                    }
                );
        }
        else if (goBack) {
            props.history.push('/');
        }
    };

    useEffect(() => {
        setModulesList(modules);
        // eslint-disable-next-line 
    }, []);

    if (modulesList.length > 0) {
        return (
            <React.Fragment>
                <ThemeProvider theme={currentTheme}>
                    <CssBaseline />
                    <Backdrop className={classes.backdrop} id="moduleOrderBackdrop" open={backDrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <Container maxWidth="xl" style={{ height: "95%" }} className={props.styles}>
                        <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                            <Toolbar>
                                <IconButton edge="start" color="inherit" onClick={() => saveModuleDisplayOrder(true)} aria-label="back">
                                    <KeyboardBackspaceIcon />
                                </IconButton>
                                <Grid container direction="row" alignItems="center">
                                    <Grid item>
                                        <Typography variant="h6" className={classes.title}>&nbsp;Module Order</Typography>
                                    </Grid>
                                    <Grid item>
                                        <StatusIcon />
                                    </Grid>
                                </Grid>
                                <Grid container justify="flex-end">
                                    <SmallMenu modified={modified} saveCallback={() => saveModuleDisplayOrder(false)} />
                                </Grid>
                            </Toolbar>
                        </AppBar>
                        <Card color="primary" style={{ height: '100%', background: currentTheme.background }}>
                            <GridContainer style={{ justifyContent: "center" }}>
                                <GridItem xs={12} sm={6} md={4} lg={3}>
                                    <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                                        <DragDropContext onDragEnd={(results) => handleDragEnd(results)}>
                                            <Droppable droppableId="tile" direction="vertical">
                                                {(provided, snapshot) => (
                                                    <div ref={provided.innerRef} {...provided.droppableProps} style={getListStyle(snapshot.isDraggingOver)}>
                                                        {modulesList.map((item, index) => (
                                                            <Draggable draggableId={item.id.toString()} index={index} key={item.id.toString()}>
                                                                {(provided, snapshot) => (
                                                                    <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}
                                                                        style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}>
                                                                        <ModuleItem title={item.title} />
                                                                    </div>
                                                                )}
                                                            </Draggable>
                                                        ))}
                                                        {provided.placeholder}
                                                    </div>
                                                )}
                                            </Droppable>
                                        </DragDropContext>
                                    </CardBody>
                                </GridItem>
                            </GridContainer>
                        </Card>
                    </Container>
                </ThemeProvider>
            </React.Fragment>
        );
    }
    else return (<></>);
}
